import React from 'react'
import styled from 'styled-components'
import AutoTooltip, { AutoTooltipContent } from 'components/Common/AutoTooltip'
import SolidExclamationCircleIcon from 'components/Luxkit/Icons/solid/SolidExclamationCircleIcon'
import { rem } from 'polished'
import { TooltipAlignments } from 'components/Common/AutoTooltip/AutoTooltipContent'
import Caption from 'components/Luxkit/Typography/Caption'

const ExclamationIcon = styled(SolidExclamationCircleIcon)`
  position: relative;
  margin-left: ${rem(5)};
  top: ${rem(3)};
`

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  discountPercent: number;
  tooltipAlignment?: TooltipAlignments;
}

function LastMinuteDiscountText(props: Props) {
  const { discountPercent, tooltipAlignment, ...rest } = props

  return (
    <Caption variant="medium" data-testid="discount-percentage" {...rest}>
      {discountPercent}% off best available rate
      <AutoTooltip>
        <ExclamationIcon size="XS" colour="primary" />
        <AutoTooltipContent width={240} alignment={tooltipAlignment}>
          Discount calculated on the best rate available for this package as reported to us by the property.{' '}
          Rate excludes the value of any package inclusions – they’re our gift to you.
        </AutoTooltipContent>
      </AutoTooltip>
    </Caption>
  )
}

export default LastMinuteDiscountText
